import { clone } from '@jack-henry/frontend-utils/functions/object.helpers';
import { Nullable } from '@jack-henry/frontend-utils/types';
import { WireFileErrorDto, WireModelDto, WireParseResultModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../shared';
import { Wire } from './wire.entity';

export const nullWireFileUpload: Nullable<WireParseResultModelDto> = {
    fileErrors: [] as WireFileErrorDto[],
    wires: [] as WireModelDto[],
};

export class WireFileUpload extends DomainEntity<Nullable<WireParseResultModelDto>> {
    constructor(dto = clone(nullWireFileUpload)) {
        super(dto);
    }

    public createDefault(): this {
        return new WireFileUpload(this.dto) as this;
    }

    public get fileErrors() {
        if (this.dto.fileErrors) {
            return this.dto.fileErrors.map(errorDto => errorDto);
        }
        return [];
    }

    public get wires() {
        if (this.dto.wires) {
            return this.dto.wires.map(wireDto => new Wire(wireDto));
        }
        return [];
    }
}
